export function toThousandFilter(num) {
    return (num || 0.00).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * @param {string} src
 * @returns {Boolean}
 */

export function isEmpty(src) {// 是否为空
    if (src == undefined) return true;
    else return /^[\s^0]*$/.test(src);
}

export function isParamEmpty(src) {// 是否为空 - 没有0
    if (src == undefined) return true;
    else return /^[\s]*$/.test(src);
}

export var patrn = (value) => {//不能输入特殊字符
    if (!/[`~!@#$%()（）《》^&*_+<>?:"{},.\/;'[\]]/im.test(value)) {
        return false
    } else {
        return true
    }
}
export var moneys = (value) => {//金额,利率，仅小数点后边两位
    if (value == '') {
        return false
    } else if (/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
        return false
    } else {
        return true
    }
}





// WEBPACK FOOTER //
// ./src/utils/filters.js